import * as TeamRegisterAction from './team-register.actions';

const TeamRegisterActionsMerge = { ...TeamRegisterAction };
export {TeamRegisterActionsMerge as TeamRegisterActions};
